import { upgradeBookingInitAction } from "../../../Actions/LogicActions/Booking/UpgradeBookingInitAction";
import { upgradeToPremiumContinueClickAction } from "../../../Actions/LogicActions/UpgradePremium/UpgradeToPremiumContinueClickAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { upgradeBookingTree } from "../../../Orchestrator/ConstantTree";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { UpgradeBookingContext } from "../Context/UpgradeBookingContext";

export class UpgradeBookingInitStep extends StepFlow {
    get stepName() { return "UpgradeBookingInit_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on({
                eventName: upgradeBookingTree.UpgradeBooking.Init,
                handler: async (payload: any) => {
                    upgradeBookingInitAction.setParams(payload.data!)
                    await upgradeBookingInitAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: upgradeBookingTree.UpgradeBooking.Continue.Click,
                handler: async (payload: any) => {
                    upgradeToPremiumContinueClickAction.setParams(payload.data!)
                    await upgradeToPremiumContinueClickAction.execute();

                    if (upgradeToPremiumContinueClickAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data: any = upgradeToPremiumContinueClickAction.result!;
                        if (data === "success") {
                            // const upgradeContext = this.getCtx<UpgradeBookingContext>("upgradeBookingContext");
                            // if (upgradeContext) {
                            //     upgradeContext.routeTo = ["CheckoutFlow"];
                            //     this.next();
                            // }

                            // Clear upgrade-specific atoms before navigating to checkout to prevent flash of old content
                            updateRecoilState("upgradeOutboundOffersAtom", null);
                            updateRecoilState("upgradeInboundOffersAtom", null);

                            // Reset addon state before /checkout mount so its useEffect doesn't emit
                            // GetBookingOffersAddOns before the new CheckoutFlow registers a subscriber,
                            // and stale legId-keyed meal data is cleared.
                            updateRecoilState("addonFlowStartedAtom", false);
                            updateRecoilState("mealPreferencesResponseAtom", {});

                            // Delay the ROUTE_CHANGE event emission slightly
                            setTimeout(() => {
                                _eventBus.emit({
                                    eventName: "ROUTE_CHANGE",
                                    data: "/checkout"
                                });
                            }, 0);
                        }
                    }
                }
            })
        )


        this.registerEventSubscription(
            _eventBus.on({
                eventName: upgradeBookingTree.UpgradeBooking.Back,
                handler: async (payload: any) => {
                    // Back returns to wherever the upgrade was started — the
                    // booking details page or the /bookings list — recorded by
                    // UpgradeToPremiumAction. Same shape as the cancel flow
                    // (CancelBookingInitStep): stored route, then the booking's
                    // own details page, then the list.
                    const bookingId = payload?.data?.bookingId;
                    const previousRoute = getRecoilStateValue<string>("upgradePreviousRouteAtom");
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: previousRoute || (bookingId ? `/bookings/details/${bookingId}` : "/bookings"),
                    });
                    updateRecoilState("upgradeOutboundOffersAtom", null);
                    updateRecoilState("upgradeInboundOffersAtom", null);
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        this.setCtx("upgradeBookingContext", UpgradeBookingContext)
        console.log("Upgrade Booking Initialize.....")
    }

}

export const UpgradeBookingInitStepDeclaration = new StepDefinition({
    stepName: "UpgradeBookingInit_Step",
    stepClass: UpgradeBookingInitStep
});